.container {
    width: 400px;
}
